import React from 'react';
import MainCard from 'ui-component/cards/MainCard';
import MaterialTable from 'material-table';
import tableIcons from 'themes/MaterialTableIcons';
import axios from 'axios';
import { Authenticated } from '../../../utils/checkerfunction';

const ViewBarcode = () => {
    // Authenticated();

    const columns = [
        { title: 'S.No', field: 'sno' },
        { title: 'Bar Code', field: 'serial_no' },
        { title: 'Uploded On', field: 'created_at' },
        { title: 'Assigned to', field: 'username' }
    ];

    const [Data, setData] = React.useState(null);

    const baseURL = `${process.env.REACT_APP_BASEURL}admin/user/getAllDnaQRCode`;

    axios.defaults.headers.common = {
        Authorization: `Bearer ${localStorage.getItem('token')}`
    };

    const array = [];
    const getData = async () => {
        const response = await axios.get(baseURL);

        response.data.responce.forEach((element) => {
            array.push(element);
        });
        setData(array);
    };

    React.useEffect(() => {
        // Authenticated();
        getData();
    }, []);

    const arr = [];

    // eslint-disable-next-line array-callback-return
    Data?.map((item, i) => {
        if (item.is_approved !== 1 && item.is_approved !== 2) {
            arr.push({
                sno: i + 1,
                serial_no: item.serial_no,
                created_at: item.created_at,
                username: item.username
            });
        }
    });

    return (
        <MainCard>
            <div>
                <MaterialTable
                    title={null}
                    icons={tableIcons}
                    columns={columns}
                    data={arr}
                    options={{
                        paging: false,
                        maxBodyHeight: '700px',
                        headerStyle: {
                            backgroundColor: '#01579b',
                            color: '#FFF',
                            fontWeight: 100
                        },

                        // eslint-disable-next-line consistent-return
                        rowStyle: (x) => {
                            if (x.tableData.id % 2) {
                                return { backgroundColor: '#eef9ff' };
                            }
                        }
                    }}
                />
            </div>
        </MainCard>
    );
};

export default ViewBarcode;
